import { h, render } from 'preact';
import Episodes from '~/components/Episodes/Episode';
import Player from '~/components/Player/Player';
import { mostRecentStore } from '../../mostRecentStore';
import MostRecent from '~/components/MostRecent/MostRecent';
import Clipboard from 'clipboard';
import PopularPodcasts from '~/components/PopularPodcasts';
import favorites from '~/favoritesStore';
import Notification from '~/notification';
import { getProgress, player as s } from '../../player/store';
import type { Episode } from '~/types/podcast';
import type { Podcast } from '@/types/podcast';

declare global {
  interface Window {
    __INITIAL_STATE:
      | {
          notfound: true;
          podcast: never;
          podcastUrl: never;
          episode?: never;
          episodeUrl?: never;
        }
      | {
          notfound?: undefined;
          podcast: Podcast;
          podcastUrl: string;
          episode?: Episode;
          episodeUrl?: string;
        };
  }
}

function podcast(/** match */) {
  // debuggin issues with cdn and builds
  // Todo: safari caches webpage on navigate and when navigate back
  // the player is a in a playing mode but no audio is.
  // We should try to reset it to  be paused
  window.onpageshow = function (event) {};
  /* Player in overlay view / BIG */
  window.addEventListener(
    'player:big.enter',
    () => {
      if (!document.documentElement.classList.contains('player--is-big')) {
        document.documentElement.className += ' player--is-big';
      }
    },
    false,
  );
  window.addEventListener(
    'player:big.leave',
    () => {
      if (document.documentElement.classList.contains('player--is-big')) {
        document.documentElement.classList.remove('player--is-big');
      }
    },
    false,
  );

  const shareButton = document.querySelector('.podcast-share');
  const shareBoard = document.querySelector('#share_pod');
  const closeShareButton = shareBoard?.querySelector('.close-share');
  const clipboard = new Clipboard('#copy_url');
  // @ts-expect-error - clipboard missing types for this api
  clipboard.on('success', () => {
    const copyButton = shareBoard?.querySelector<HTMLSpanElement>('#copy_url > span');
    const rawText = copyButton?.innerText;

    if (copyButton && rawText) {
      copyButton.innerText = 'Kopierad!';
      setTimeout(() => {
        shareBoard?.classList.add('hidden');
        copyButton.innerText = rawText;
      }, 400);
    }
  });

  closeShareButton?.addEventListener('click', (e) => {
    e.stopPropagation();
    shareBoard?.classList.add('hidden');
  });

  shareButton?.addEventListener('click', (e) => {
    e.stopPropagation();
    shareBoard?.classList.remove('hidden');
  });

  document.addEventListener('click', (e: MouseEvent) => {
    if (shareBoard?.classList.contains('hidden')) {
      return;
    }

    if (!shareBoard?.contains(e.target as Node)) {
      shareBoard?.classList.add('hidden');
    }
  });

  if (typeof window.__INITIAL_STATE === 'undefined') {
    return;
  }
  if (window.__INITIAL_STATE.notfound === true) return;

  const podcast = window.__INITIAL_STATE.podcast;

  const likeButton = document.querySelector('.js-podcast-like');
  const [animatedHeart, baseHeart] = likeButton?.querySelectorAll('svg');

  const notification = new Notification(document.querySelector('.js-liked-podcast-toast'), {
    hideAfter: 8000,
  });

  if (favorites.has(podcast.itunes_id)) {
    baseHeart.classList.add('fill-primary');
  }

  likeButton?.addEventListener('click', (e) => {
    if (favorites.has(podcast.itunes_id)) {
      baseHeart.classList.remove('fill-primary');
      animatedHeart.classList.remove('animate-ping-once');
      animatedHeart.classList.add('hidden');
      favorites.remove(podcast.itunes_id);
      // track('Podcast unlike', {
      //   props: {
      //     location: 'podcast:show',
      //     title: podcast.title,
      //   },
      // });
    } else {
      if (favorites.getAll().length <= 0) {
        notification.show();
      }
      // track('Podcast like', {
      //   props: {
      //     title: podcast.title,
      //   },
      // });
      animatedHeart.classList.remove('hidden');
      animatedHeart.classList.add('animate-ping-once');
      baseHeart.classList.add('fill-primary');
      favorites.add(podcast.itunes_id, 'podcast');
    }
    e.preventDefault();
  });

  const listenButton = document.querySelector('button.podcast_listen');
  if (listenButton) {
    listenButton.addEventListener('click', (e) => {
      s.play(
        podcast.meta.episodes[0],
        podcast,
        getProgress(podcast.meta.episodes[0], podcast.itunes_id).currentSeek,
      );
      e.preventDefault();
    });
  }

  const adDark = document.querySelector('.ad-dark');
  if (adDark) {
    const { x, y } = adDark.getBoundingClientRect();
    if (x === 0 && y === 0 && window.innerWidth > 1200) {
      const bc = document.querySelector('.bc');
      if (bc) {
        const pb = window.getComputedStyle(bc).getPropertyValue('padding-bottom');

        bc.setAttribute('style', `padding-bottom: ${+pb.replace('px', '') - 200}px`);
      }
    }
  }

  mostRecentStore.load().trackVisit(podcast.itunes_id);

  const mountPlayerNode = document.getElementById('playerplace');
  const firstEpisode = podcast.meta.episodes[0];
  if (!firstEpisode) {
    console.error('No episodes found for podcast', podcast.itunes_id);
    return;
  }
  if (mountPlayerNode) {
    s.mount(firstEpisode, podcast, getProgress(firstEpisode, podcast.itunes_id).currentSeek);

    render(h(Player, { store: s }), mountPlayerNode);
  }

  const episodesNode = document.querySelector('.episodes');
  if (episodesNode?.parentElement) {
    episodesNode.innerHTML = '';
    render(
      h(Episodes, {
        store: s,
        podcast,
        title: podcast.title,
        header: 'Fler avsnitt av',
        podcastUrl: window.__INITIAL_STATE.podcastUrl,
      }),
      episodesNode.parentElement,
    );
  }
  const popularPodcastsNode = document.querySelector('#popularpodcasts');
  if (popularPodcastsNode) {
    render(
      h(PopularPodcasts, {
        title: 'Populärt på poddtoppen just nu',
        action: '/populara',
      }),
      popularPodcastsNode,
    );
  }

  const mostRecentNode = document.querySelector('#mostrecent');
  if (mostRecentNode) {
    render(
      h(MostRecent, {
        title: 'Senast besökta',
      }),
      mostRecentNode,
    );
  }
}

podcast();
